import React from 'react';
import PropTypes from 'prop-types';

const CustomDateComponent = (props) => {
	// Convert the input date value to this format Jan 29, 2024
	const inputDate = new Date(props?.value);
	const formattedDate = new Intl.DateTimeFormat('en-US', {
		year: 'numeric',
		month: 'short',
		day: '2-digit',
	}).format(inputDate);

	return <div>{formattedDate}</div>;
};

CustomDateComponent.propTypes = {
	value: PropTypes.any,
};

export default CustomDateComponent;
